import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import XMLViewer from "react-xml-viewer-2";
import { FakeText } from "@totalsoft/rocket-ui";
import { loadPartnerLog } from "features/partner/actionCreators";
import { getPartnerLog } from "features/partner/selectors";
import { connect } from "react-redux";

const LogValue = ({ actions, partnerLogId, content, loading }) => {
  useEffect(() => {
    actions.loadPartnerLog(partnerLogId);
  }, [actions, partnerLogId]);

  return loading ? <FakeText lines={5} /> : <XMLViewer xml={content}></XMLViewer>;
};

LogValue.propTypes = {
  actions: PropTypes.object.isRequired,
  partnerLogId: PropTypes.number.isRequired,
  content: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired
};

const mapStateToProps = (state, ownProps) => {
  const { loading, content } = getPartnerLog(state, ownProps.partnerLogId);

  return {
    content,
    loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators({ loadPartnerLog }, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogValue);
